var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D1440/01-01-Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-796.000000, -2878.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slider",
    transform: "translate(200.000000, 2244.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slider-navigation",
    transform: "translate(376.000000, 621.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(221.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#414756",
    fill: "#FFFFFF",
    cx: 33.5,
    cy: 33.5,
    r: 33.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0033964,34.9732815 L31.8585827,42.1180952 C31.191916,42.7847618 30.1110358,42.7847618 29.4443691,42.1180952 C28.7777025,41.4514285 28.7777025,40.3705483 29.4443691,39.7038816 L35.4967748,33.6514759 L29.4666193,27.6213203 C28.7999526,26.9546537 28.7999526,25.8737734 29.4666193,25.2071068 C30.1332859,24.5404401 31.2141662,24.5404401 31.8808328,25.2071068 L39.1234735,32.4497475 C39.7901402,33.1164141 39.7901402,34.1972944 39.1234735,34.863961 C39.0847886,34.902646 39.0447089,34.9390861 39.0033964,34.9732815 Z",
    id: "Combined-Shape",
    fill: "#414756"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightActive);
export default __webpack_public_path__ + "static/media/chevronRightActive.a96f7494.svg";
export { ForwardRef as ReactComponent };